enum EApiProfile {
  companyLogo = '/externals/cargo-owners/company-logo',
}

export default EApiProfile;
